import { render } from "./ShipmentToTopCountries.vue?vue&type=template&id=97edc3ec&ts=true"
import script from "./ShipmentToTopCountries.vue?vue&type=script&lang=ts"
export * from "./ShipmentToTopCountries.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__